import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Active: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M14.2222222,14.2222222 L1.77777778,14.2222222 L1.77777778,1.77777778 L10.6666667,1.77777778 L10.6666667,0 L1.77777778,0 C0.791111111,0 0,0.791111111 0,1.77777778 L0,14.2222222 C0,15.2040618 0.795938223,16 1.77777778,16 L14.2222222,16 C15.2040618,16 16,15.2040618 16,14.2222222 L16,7.11111111 L14.2222222,7.11111111 L14.2222222,14.2222222 Z M4.36444444,6.29333333 L3.11111111,7.55555556 L7.11111111,11.5555556 L16,2.66666667 L14.7466667,1.40444444 L7.11111111,9.04 L4.36444444,6.29333333 Z"
        />
    </SvgIcon>
);

export default Active;
